import { render, staticRenderFns } from "./MitComputingPage.vue?vue&type=template&id=71ae5c34&scoped=true"
import script from "./MitComputingPage.vue?vue&type=script&lang=js"
export * from "./MitComputingPage.vue?vue&type=script&lang=js"
import style0 from "./MitComputingPage.vue?vue&type=style&index=0&id=71ae5c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae5c34",
  null
  
)

export default component.exports